export default __webpack_public_path__ + "static/lozenge-do-1-dark-ae1db7d02bb71cbd2f76bf8a044258e2.png";